import React from "react";
import { MapPin, ChevronDown } from "react-feather";
import { useBranchFilter } from "../../features/branchFilter/useBranchFilter";

// Header branch-picker (handoff §13.1): narrows every branch-scoped list
// screen (Customers, Products, Employees, Users) to one branch at a time via
// &branchId=. A branch-scoped (non all-branch) user only ever sees their own
// branch(es) here - no "All branches" option, so the picker is effectively
// just a label for them (the server would reject any other branchId anyway).
// Styled as a filled, colored badge (not a bare default <select>) - the
// plain-text-box look was hard to notice at a glance, direct instruction.
const BranchPicker = () => {
  const { selectedBranchId, setSelectedBranchId, availableBranches, showAllOption, allOptionLabel } =
    useBranchFilter();

  if (availableBranches.length === 0) return null;
  if (!showAllOption && availableBranches.length === 1) {
    return (
      <div className="d-none d-md-flex align-items-center branch-picker-badge me-3">
        <MapPin size={14} className="me-1" />
        <span>{availableBranches[0].branchCode}</span>
      </div>
    );
  }

  return (
    <div className="d-none d-md-flex align-items-center branch-picker-badge me-3">
      <MapPin size={14} className="me-1" />
      <select
        className="branch-picker-select"
        value={selectedBranchId ?? ""}
        onChange={(e) => setSelectedBranchId(e.target.value ? Number(e.target.value) : null)}
      >
        {showAllOption && <option value="">{allOptionLabel}</option>}
        {availableBranches.map((b) => (
          <option key={b.branchId} value={b.branchId}>
            {b.branchCode}
          </option>
        ))}
      </select>
      <ChevronDown size={14} className="ms-1" />
    </div>
  );
};

export default BranchPicker;
